module.exports = __webpack_public_path__ + "media/svg/times-e4fcac34.svg";